export default __webpack_public_path__ + "static/media/vroom1.f5b90028.PNG";